import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrl: './status-bar.component.scss',
  standalone: false
})
export class StatusBarComponent {
  @Input() colored: boolean = false;
}
